import { Navbar } from './components/navbar';
import { initScrollAnimations } from './components/scroll-animations';
import { initLenis } from './functions/lenis-scroll';
import { initScrollZoomOnScroll } from './functions/scrollZoomOnScroll';
import { initBannerHeroBackgroundVideo } from './functions/bannerHeroVideo';
import { initMasonryExpandableCards } from './functions/masonryExpandableCards';
import { initFormSelects } from './functions/formSelect';
import { initFooterAccordion, initFooterMenuAnchorOffset } from './footer.js';

var documentReady = function () {
    initLenis();
    initFooterAccordion();
    initFooterMenuAnchorOffset();
    Navbar();
    initScrollAnimations();
    initScrollZoomOnScroll();
    initBannerHeroBackgroundVideo();
    initMasonryExpandableCards();
    initFormSelects();
};

if (
    document.readyState === 'complete' ||
    (document.readyState !== 'loading' && !document.documentElement.doScroll)
) {
    documentReady();
} else {
    document.addEventListener('DOMContentLoaded', documentReady);
}
